import React from 'react';

import { BackButton, ContractNumber, Header, LeftSection } from './ContractSubViewHeader.styled';

export type ContractSubViewHeaderProps = {
  contractId: string;
  onBack: () => void;
};

export function ContractSubViewHeader({ contractId, onBack }: ContractSubViewHeaderProps) {
  return (
    <Header>
      <LeftSection>
        <ContractNumber>
          Contrato nº <strong>{contractId}</strong>
        </ContractNumber>
      </LeftSection>
      <BackButton type="button" onClick={onBack}>
        ← Voltar
      </BackButton>
    </Header>
  );
}
